import Button from 'components/shared/Buttons/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Allowed from 'components/shared/Permissions/Allowed';

const HeaderActions = ({ onAddNewRoleClick, forAdmin }) => {
  return (
    <div className="flex items-center gap-2">
      <Allowed requiredPermissions={forAdmin ? 'admin_role.create' : 'role.create'}>
        <Button
          text="New Role"
          icon="add-square-mono"
          size="small"
          transparent
          iconColor="white"
          onClick={onAddNewRoleClick}
          textClassName="whitespace-nowrap"
        />
      </Allowed>
    </div>
  );
};

export default withErrorBoundary(HeaderActions);
